import React, {useEffect, useState} from "react";
import fetchTournaments from "../../api/fetchTournaments";
import styles from "./competitionsPage.module.css";
import Header from "../header/header";
import {Link} from "react-router-dom";

const competitionsPageMenu = [
    {
        name: 'Tournaments',
        link: '/tournaments'
    },
    {
        name: 'Calendar',
        link: '/matches'
    }
]
interface Tournament {
    id: number
    name: string
    fk_parent: number
    suggested_start_date: string
    suggested_end_date: string
    actual_start_date: string
    actual_end_date: string
    age_group: string
    gender: string
    logo: string
    short_name: string
    type: string
    season: Season
    teams_type: string
}

interface Season {
    id: number
    name: string
}
const CompetitionsPage: React.FC = () => {
    const [tournaments, setTournaments] = useState<Tournament[]>([]);

    const getAllTournaments = async () => {
        try {
            const data = await fetchTournaments()
            setTournaments(data)
        } catch (error) {
            console.error ('Error fetching persons stats data:', error)
        }
    }

    useEffect(() => {
        getAllTournaments()
    }, [])

    useEffect(() => {
        console.log('Tournaments state:', tournaments);
    }, [tournaments])

    const sortedTournaments = [...tournaments].sort((a, b) => {
        // If both tournaments have dates, compare them
        if (a.actual_start_date && b.actual_start_date) {
            return new Date(b.actual_start_date).getTime() - new Date(a.actual_start_date).getTime();
        }
        // If only a has a date, it should come first
        if (a.actual_start_date) return -1;
        // If only b has a date, it should come first
        if (b.actual_start_date) return 1;
        // If neither has a date, maintain their original order
        return 0;
    });

    return (
        <>
            <Header title={'Competitions'} menu={competitionsPageMenu} />
            <main>
                <ul className={styles.tournaments_list}>
                    {sortedTournaments.map((tournament) => (
                            <li className={styles.tournament_card} key={tournament.id}>
                                <div className={styles.tournament_card__content}>
                                    <div className={styles.logo_container}>
                                        { tournament.logo && (
                                            <img className={styles.tournament_card__img} src={tournament.logo} alt={tournament.short_name}/>
                                        )}
                                        {tournament.actual_start_date &&
					                                <div className={styles.calendar__tag}>
						                                <img src={'http://pitchinvasion.ru/files/icons/calendar.svg'}/>
                                              {tournament.actual_start_date} – {tournament.actual_end_date}
					                                </div>
                                        }
                                    </div>
                                    <Link to={`/tournaments/${tournament.id}`}>
                                        <h3>{tournament.short_name}&nbsp;{tournament.season.name}</h3>
                                    </Link>
                                </div>
                                <ul className={styles.tournament__tags}>
                                    {tournament.gender &&
                                      <li className={styles.tournament__tag}>{tournament.gender}</li>
                                    }
                                    {tournament.teams_type &&
                                      <li className={styles.tournament__tag}>{tournament.teams_type}</li>
                                    }
                                </ul>

                            </li>
                    ))}
                </ul>
            </main>
        </>
    )
}

export default CompetitionsPage

